export enum DashboardAction {
  AddBox = 1,
  BoxAdded = 2,
  BoxEdited = 3,
  RemoveBox = 5,
  BoxRemoved = 6,
  LayoutChanged = 20
}
